import { LazyLoader, Modal } from '@bp/ui-components';
import { FragmentType } from 'client/gql';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CourseViewersForm, CourseViewersFormFragment } from '../forms/CourseViewersForm';

type CourseViewersModalProps = {
  isOpen: boolean;
  courseUuid: string;
  schoolYearUuid: string;
  onClose: () => void;
  query: FragmentType<typeof CourseViewersFormFragment> | undefined;
};

export const CourseViewersModal = ({ isOpen, courseUuid, schoolYearUuid, onClose, query }: CourseViewersModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal loading={loading} isOpen={isOpen} onRequestClose={onClose} title={t('courses.editViewers')}>
      <Suspense fallback={<LazyLoader embedded forceHeight='58vh' />}>
        <CourseViewersForm
          query={query}
          courseUuid={courseUuid}
          schoolYearUuid={schoolYearUuid}
          onLoad={setLoading}
          onClose={onClose}
        />
      </Suspense>
    </Modal>
  );
};
